import { render, staticRenderFns } from "./MiniDashDePedidos.vue?vue&type=template&id=146a29ae&scoped=true&"
import script from "./MiniDashDePedidos.vue?vue&type=script&lang=ts&"
export * from "./MiniDashDePedidos.vue?vue&type=script&lang=ts&"
import style0 from "./MiniDashDePedidos.vue?vue&type=style&index=0&id=146a29ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a29ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VChip,VCol,VDivider,VIcon,VProgressCircular,VRow})
